import { ThunkAction } from 'redux-thunk';

import { TagsResult, tags } from '../services/contractApi';
export { TagsResult } from '../services/contractApi';

/**
 * タグ取得用モジュール
 */
export interface TagsState {
  tags: TagsResult | null;
  tagsMessages: string[];
  status: number;
}

const initialState: TagsState = {
  tags: null,
  tagsMessages: [],
  status: 0,
};

const REQUEST_GET_TAGS = 'REQUEST_GET_TAGS';
type REQUEST_GET_TAGS = typeof REQUEST_GET_TAGS;

const RECEIVE_TAGS = 'RECEIVE_TAGS';
type RECEIVE_TAGS = typeof RECEIVE_TAGS;

const FAIL_GET_TAGS = 'FAIL_GET_TAGS';
type FAIL_GET_TAGS = typeof FAIL_GET_TAGS;

const CLEAR_TAGS = 'CLEAR_TAGS';
type CLEAR_TAGS = typeof CLEAR_TAGS;

const CLEAR_GET_TAGS_MESSAGES = 'CLEAR_GET_TAGS_MESSAGES';
type CLEAR_GET_TAGS_MESSAGES = typeof CLEAR_GET_TAGS_MESSAGES;

interface RequestGetTags {
  type: REQUEST_GET_TAGS;
}

interface ReceiveTags {
  type: RECEIVE_TAGS;
  tags: TagsResult;
}

interface FailGetTags {
  type: FAIL_GET_TAGS;
  messages: string[];
  status: number;
}

interface ClearTags {
  type: CLEAR_TAGS;
}

interface ClearGetTagsMessages {
  type: CLEAR_GET_TAGS_MESSAGES;
}

export type TagsAction = RequestGetTags | ReceiveTags |
  FailGetTags | ClearTags | ClearGetTagsMessages;

type Tags =
  ThunkAction<void, TagsState, undefined, TagsAction>;

export function requestGetTags(): RequestGetTags {
  return {
    type: REQUEST_GET_TAGS,
  };
}

export function receiveTags(tags: TagsResult): ReceiveTags {
  return {
    tags,
    type: RECEIVE_TAGS,
  };
}

export function failGetTags(messages: string[], status: number): FailGetTags {
  return {
    messages,
    status,
    type: FAIL_GET_TAGS,
  };
}

export function clearTags(): ClearTags {
  return {
    type: CLEAR_TAGS,
  };
}

export function clearGetTagsMessages(): ClearGetTagsMessages {
  return {
    type: CLEAR_GET_TAGS_MESSAGES,
  };
}

export function getTags(): Tags {
  return (dispatch) => {
    dispatch(clearTags());
    dispatch(requestGetTags());
    // タグ取得API呼び出し
    return tags().then((res) => {
      const { status, result, messages, status_code } = res;
      if (status === 200 && result) {
        dispatch(receiveTags(result));
      } else {
        dispatch(failGetTags(messages, status_code));
      }
    }).catch((err) => {
      dispatch(failGetTags([String(err)], 500));
    });
  };
}

export default function reducer(
  state: TagsState | undefined,
  action: TagsAction,
): TagsState {
  if (!state) return initialState;
  switch (action.type) {
    case REQUEST_GET_TAGS: {
      return state;
    }
    case RECEIVE_TAGS: {
      const { tags } = action;
      return { tags, tagsMessages: [], status: 200 };
    }
    case FAIL_GET_TAGS: {
      const { messages, status } = action;
      return { ...state, status, tagsMessages: messages };
    }
    case CLEAR_TAGS: {
      return initialState;
    }
    case CLEAR_GET_TAGS_MESSAGES: {
      return { ...state, tagsMessages: [], status: 0 };
    }
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/modules/tags.ts